<span class="approval-container">
  <span class="me-3">
    <mat-checkbox
      #pageSelector
      [disabled]="bulkSelectControl"
      (change)="togglePageSelect($event)"
    >
      Select Page
    </mat-checkbox>
  </span>
  <span class="me-3">
    <mat-checkbox
      [checked]="bulkSelectControl"
      (change)="toggleBulkSelect($event)"
    >
      Select All
    </mat-checkbox>
  </span>
  <mat-form-field class="me-2">
    <mat-label>Bulk Action</mat-label>
    <mat-select [formControl]="bulkActionControl">
      @for (option of bulkActionOptions; track option.value) {
        <mat-option value="{{ option.value }}">
          {{ option.display }}
        </mat-option>
      }
    </mat-select>
    @if (bulkActionControl.value) {
      <button
        type="button"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        color="warn"
        matTooltip="Clear Action"
        (click)="resetBulkAction($event)"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
  <button
    type="button"
    mat-raised-button
    color="primary"
    [disabled]="
      !bulkActionControl.value ||
      (!bulkSelectControl &&
        !pageSelector.checked &&
        selectedTradeList?.length <= 0)
    "
    (click)="executeBulkAction()"
  >
    Execute
  </button>
</span>
